




























import {
  defineComponent,
  ref,
  computed,
  useStore,
} from '@nuxtjs/composition-api'
import { VueSlideToggle } from 'vue-slide-toggle'
import BlockText from '@/components/BlockText'

export default defineComponent({
  name: 'BlockWarning',
  components: { BlockText, VueSlideToggle },
  props: {
    title: {
      type: String,
      default: '',
    },
    textPreview: {
      type: String,
      default: '',
    },
    textToOpen: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const store = useStore()
    const button = computed(() => ({
      open: props.buttonText || store.getters['settings/btnShowMore'],
      close: store.getters['settings/btnRollUp'],
    }))
    const isOpen = ref(false)
    const duration = ref(300)
    const blockWarningStyles = computed(() => ({
      '--block-warning-background': props.backgroundColor,
      '--block-warning-color': props.textColor,
    }))

    const onClick = () => {
      isOpen.value = !isOpen.value
    }

    return {
      isOpen,
      duration,
      onClick,
      button,
      blockWarningStyles,
    }
  },
})
